'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createIdGuard, Box } from '@s7/base';
import { useId, useUncontrolled } from '@s7/hooks';
import { useProps } from '@s7/styles';
import { isArray } from '@s7/utils';
import { AccordionContextProvider } from './Accordion.context.js';
import { IDENT_ACCORDION, accordionDefaultProps } from './Accordion.contract.js';
import { ACCORDION_ERRORS_VALUE } from './Accordion.errors.js';
import useStyles from './Accordion.styles.js';
import { AccordionItem } from './AccordionItem/AccordionItem.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _Accordion(props, ref) {
    var _useProps = useProps(IDENT_ACCORDION, accordionDefaultProps, props), _useProps_ = _useProps[0], id = _useProps_.id, loop = _useProps_.loop, children = _useProps_.children, multiple = _useProps_.multiple, value = _useProps_.value, defaultValue = _useProps_.defaultValue, onChange = _useProps_.onChange, transitionDuration = _useProps_.transitionDuration, disableChevronRotation = _useProps_.disableChevronRotation, chevronPosition = _useProps_.chevronPosition, chevronSize = _useProps_.chevronSize, chevron = _useProps_.chevron, className = _useProps_.className, sxs = _useProps[1], others = _object_without_properties_loose(_useProps[0], [
        "id",
        "loop",
        "children",
        "multiple",
        "value",
        "defaultValue",
        "onChange",
        "transitionDuration",
        "disableChevronRotation",
        "chevronPosition",
        "chevronSize",
        "chevron",
        "className"
    ]);
    var uid = useId(id);
    var _useUncontrolled = useUncontrolled({
        value: value,
        defaultValue: defaultValue,
        finalValue: multiple ? [] : null,
        onChange: onChange
    }), _value = _useUncontrolled[0], handleChange = _useUncontrolled[1];
    var _useStyles = useStyles(null, sxs, IDENT_ACCORDION), classes = _useStyles[0], cx = _useStyles[1];
    var isItemActive = function(itemValue) {
        return isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
    };
    var handleItemChange = function(itemValue) {
        var nextValue = isArray(_value) ? _value.includes(itemValue) ? _value.filter(function(selectedValue) {
            return selectedValue !== itemValue;
        }) : [].concat(_value, [
            itemValue
        ]) : itemValue === _value ? null : itemValue;
        handleChange(nextValue);
    };
    return /*#__PURE__*/ jsx(AccordionContextProvider, {
        value: {
            isItemActive: isItemActive,
            onChange: handleItemChange,
            getControlId: createIdGuard("" + uid + "-control", ACCORDION_ERRORS_VALUE),
            getRegionId: createIdGuard("" + uid + "-panel", ACCORDION_ERRORS_VALUE),
            transitionDuration: transitionDuration,
            disableChevronRotation: disableChevronRotation,
            chevronPosition: chevronPosition,
            chevronSize: chevronSize,
            chevron: chevron,
            loop: loop
        },
        children: /*#__PURE__*/ jsx(Box, _extends({
            ref: ref
        }, others, {
            className: cx(classes.root, className),
            "data-accordion": true,
            children: children
        }))
    });
}
var Accordion = /*#__PURE__*/ forwardRef(_Accordion);
Accordion.Item = AccordionItem;
Accordion.displayName = IDENT_ACCORDION;
var Accordion$1 = Accordion;

export { Accordion, Accordion$1 as default };
